import { useState } from 'react';
import { Button, Icon } from '@vp/swan';
import { useChatActions } from '../contexts/ChatContext';
import { buildHelpRequestPayload } from '../utils/isHelpRequestMessage';

export interface HelpMeAnswerButtonProps {
    selectorType: string;
    options?: ReadonlyArray<object>;
    onHelpRequest?: () => void;
}

export function HelpMeAnswerButton({
    selectorType,
    options,
    onHelpRequest,
}: HelpMeAnswerButtonProps) {
    const [isDisabled, setIsDisabled] = useState(false);
    const { sendText } = useChatActions();

    const handleClick = async () => {
        setIsDisabled(true);
        try {
            const payload = buildHelpRequestPayload(selectorType, options);
            await sendText(payload);
            onHelpRequest?.();
        } catch (error) {
            setIsDisabled(false);
        }
    };

    return (
        <Button skin="tertiary" iconPosition="left" onClick={handleClick} disabled={isDisabled}>
            <Icon iconType="aiSupport" />
            Help me answer
        </Button>
    );
}
